"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const text_1 = require("./text");
const React = require("react");
const Field = require("./formField");
function parseValue(val) {
    const phoneRegex = /((?:\d|-|\s|\t|,)+)\s*(?:ext\.\s+(.*))?/;
    if (phoneRegex.test(val)) {
        const result = phoneRegex.exec(val);
        return { phone: result[1], ext: result[2] };
    }
    else {
        return { phone: val, ext: "" };
    }
}
function valueToString(value) {
    return value.ext ? value.phone + " ext. " + value.ext : value.phone;
}
class Phone extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handlePhoneChange = (value) => {
            if (this.props.onChange) {
                this.props.onChange(valueToString(Object.assign({}, this.parsedValue, { phone: value })));
            }
        };
        this.handleExtChange = (value) => {
            if (this.props.onChange) {
                this.props.onChange(valueToString(Object.assign({}, this.parsedValue, { ext: value })));
            }
        };
    }
    get parsedValue() {
        return parseValue(this.props.value || "");
    }
    render() {
        const parse = this.parsedValue;
        return (React.createElement(Field.FormField, { label: this.props.label, error: this.props.error },
            React.createElement("div", { style: { display: "flex" } },
                React.createElement("div", { style: { flex: "3 0 0" } },
                    React.createElement(text_1.Text, { value: parse.phone, onChange: this.handlePhoneChange, placeholder: "tel\u00E9fono" })),
                !this.props.hideExtension &&
                    React.createElement("div", { style: { flex: "1 0 0" } },
                        React.createElement(text_1.Text, { value: parse.ext, onChange: this.handleExtChange, placeholder: "ext." })))));
    }
}
exports.Phone = Phone;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/fields/phone.js
// module id = 2212
// module chunks = 0